import { render } from "./createMarket.vue?vue&type=template&id=6f015a02&scoped=true"
import script from "./createMarket.vue?vue&type=script&lang=js"
export * from "./createMarket.vue?vue&type=script&lang=js"

import "./createMarket.vue?vue&type=style&index=0&id=6f015a02&scoped=true&lang=css"

import exportComponent from "/home/quantum/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f015a02"]])

export default __exports__